export function parse(queryString) {
  const tokens = queryString.slice(1).split('&')
  return tokens.reduce((params, token) => {
    const [key, value] = token.split('=')
    params[key] = value
    return params
  }, {})
}



// WEBPACK FOOTER //
// ./src/service/query.js